import React, { useEffect, useState } from 'react';
import { FaBars, FaTimes, FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsWhatsapp } from "react-icons/bs";
import { Link } from 'react-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Navbar = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [nav, setNav] = useState(false);

    const links = [
        {
            id: 1,
            link: 'home',
            name: 'Home'
        },
        {
            id: 2,
            link: "about",
            name: 'About'
        },
        {
            id: 3,
            link: "skills",
            name: 'Skills'
        },
        {
            id: 4,
            link: "works",
            name: 'works'
        },
        {
            id: 5,
            link: "contact",
            name: 'Contact'
        },
    ];

    return (
        <div className="flex justify-between items-center w-full h-20 px-4 md:px-16 md:py-8 text-white sticky top-0 z-30 bg-[#070716]">
            <div>
                <a href="/">
                    <h1 className="text-4xl font-title ml-2 text-cyan-500"
                        data-aos-offset="100"
                        data-aos-easing="ease-in-sine">Shafkat Saad</h1>
                </a>
            </div>

            <ul className="hidden md:flex">
                {links.map(({ id, link, name }) => (
                    <li
                        key={id}
                        className="px-4 cursor-pointer capitalize text-lg font-medium hover:underline underline-offset-8 decoration-info"
                    >
                        <Link spy={true}
                            smooth={true}
                            hashSpy={true}
                            offset={-100}
                            duration={500}
                            isDynamic={true} to={link} >
                            {name}
                        </Link>
                    </li>
                ))}
            </ul>

            <div
                onClick={() => setNav(!nav)}
                className="cursor-pointer pr-4 z-10 md:hidden"
            >
                {nav ? <FaTimes size={30} /> : <FaBars size={30} />}

            </div>

            {nav && (
                <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b bg-[#070716]">
                    {links.map(({ id, link, name }) => (
                        <li
                            key={id}
                            className="px-4 cursor-pointer capitalize py-6 text-2xl hover:scale-105 duration-200"
                        >
                            <Link
                                onClick={() => setNav(!nav)}
                                to={link}
                                spy={true}
                                smooth={true}
                                hashSpy={true}
                                offset={-100}
                                duration={500}
                                isDynamic={true}
                            >
                                {name}
                            </Link>
                        </li>
                    ))}
                    <div>
                        <div className="flex items-center justify-center mt-16">
                            <a href="https://www.linkedin.com/in/shafkat-saad/"><FaLinkedin size={25} /></a>
                            <a href="https://github.com/sabidalam"><FaGithub size={25} className='ml-4' /></a>
                            <a href="https://www.instagram.com/_sporsho___/"><FaInstagram size={25} className='ml-4' /></a>
                            <a href="https://api.whatsapp.com/send?phone=01521567825"><BsWhatsapp size={25} className='ml-4' /></a>
                            <a href="mailto:shafkatsaad@gmail.com"><HiOutlineMail size={30} className='ml-4' /></a>

                        </div>
                    </div>
                </ul>
            )}
        </div>
    );
};

export default Navbar;